<template>
  <div class="programmes-wrap">
    <!-- {{ugProgrammes}} -->
    <div class="block" v-if="!loading">

      <!-- <input v-model="searchTerm" type="text"> -->
      <!-- {{filteredProgrammes}} -->
      <search-filter 
        :searchTerm.sync="searchTerm"
        :gradLevel="gradLevel"
        />

        <div class="clearfix">
          <button 
          class="level-toggle primary"
          @click="switchLevel"
          > Show {{printSwitchLevel}} subjects</button>
        </div>

        <div v-if="filteredProgrammes.length === 0">
          <p>No results found for <strong>{{searchTerm}}</strong>, <a :href="`/search?q=${searchTerm}`">search for {{searchTerm}}.</a></p>
        </div>
    
    
      <ugprogramme 
        v-for="prog in filteredProgrammes"
        :key="prog.key"
        :prog="prog"
      />
    </div>
    <div v-else>
      <p>Loading subjects...</p>
    </div>
  </div>
</template>

<script>
  import ugprogramme from './UGProgramme.vue'
  import searchFilter from './SearchFilter.vue'
  
  export default {
    name: 'UgProgrammes',
    props: ['ugProgrammes', 'loading', 'level'],
    components: {
      ugprogramme,
      searchFilter
    },
    data () {
      return {
        searchTerm: '',
        gradLevel: this.level
      }
    },
    computed: {
      filteredProgrammes () {
        let filteredProgs = this.ugProgrammes.filter( ( prog ) => {

          //exlcudes blank obj issue
          if(prog.assetId) {
            // check for maori no macron ā
            if (this.searchTerm.toLowerCase().includes('mao') && prog.name.toLowerCase().includes('māo') ) {
              return prog;
            } 
            else if (prog.name.toLowerCase().includes( this.searchTerm.toLowerCase() )) {
              return prog;
            }
            else {
              return prog.searchKeywords.toLowerCase().includes( this.searchTerm.toLowerCase() );
            }

          }
        })

        let alphabetisedProgs = filteredProgs.sort( ( a, b ) => {
          return a.name.localeCompare(b.name)
        }) 
        return alphabetisedProgs;
        // return filteredProgs;
      },
      printLevel () {
      return (this.gradLevel == 'ug') ? 'undergraduate' : 'postgraduate';
      },
      printSwitchLevel () {
        return (this.gradLevel == 'ug') ? 'Postgraduate' : 'Undergraduate';
      }
    },
    methods: {
      switchLevel () {
        (this.gradLevel == 'ug') ? this.gradLevel = 'pg' : this.gradLevel = 'ug';
        this.$emit('update:level', this.gradLevel)
        // this.$emit('buttonClicked')
      }
    }
  }

</script>

<style lang="scss" scoped>
.level-toggle {
  float: right;
  margin-bottom: 1rem;
}

</style>